import React from 'react';

const Login: React.FC = () => {
  // Environment-based configuration
  const clientId = import.meta.env.VITE_YANDEX_CLIENT_ID || '1d83356719e642b9b30a94a5de549d8a';
  const redirectUri = import.meta.env.VITE_YANDEX_REDIRECT_URI || 
    (window.location.hostname === 'localhost' 
      ? 'http://localhost:3000/oauth/callback' 
      : 'https://wo.svsitunov.online/oauth/callback');

  const handleLogin = () => {
    if (clientId === 'YOUR_CLIENT_ID') {
      console.error('Yandex Client ID not configured. Please set REACT_APP_YANDEX_CLIENT_ID environment variable.');
      alert('OAuth configuration missing. Please check environment settings.');
      return;
    }

    const yandexAuthUrl = `https://oauth.yandex.com/authorize?response_type=code&client_id=${clientId}&redirect_uri=${encodeURIComponent(redirectUri)}`;
    console.log('Redirecting to:', yandexAuthUrl);
    window.location.href = yandexAuthUrl;
  };

  return (
    <div>
      <button onClick={handleLogin}>Login with Yandex</button>
    </div>
  );
};

export default Login; 